import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = {
  id: "users-table",
  class: "bg-white rounded-lg shadow-sm border border-gray-200"
}
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_4 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_7 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_10 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_13 = { class: "px-6 py-4 border-t border-gray-200" }
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "text-sm text-gray-700" }
const _hoisted_16 = { class: "font-medium" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_19 = { class: "px-3 py-1 bg-blue-600 text-white rounded text-sm" }

import { onMounted, ref } from 'vue';
import { useBillingStore } from '@/store/billing';
import { formatCharge } from '@/utils/chargeHandler';

import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ledger',
  setup(__props) {

const billingStore = useBillingStore();
const showModal = ref<boolean>(false);

onMounted(() => {
  const purpose = localStorage.getItem('purpose');

  if (purpose === 'public') {
    billingStore.fetchLedger(1);
  } else if (purpose === 'local') {
    billingStore.fetchAdminLedger(1);
  }
});

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("div", {
        id: "page-header",
        class: "mb-8"
      }, [
        _createElementVNode("div", { class: "flex items-center justify-between" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-2xl font-bold text-green-800" }, "Billing Managment"),
            _createElementVNode("p", { class: "mt-2 text-gray-600 text-sm" }, "All requests on your organization ledger are found here")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_unref(billingStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
            ])))
          : _createCommentVNode("", true),
        (!_unref(billingStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Request ID"),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Amount"),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(billingStore).lederResults, (ledger) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      id: "user",
                      key: ledger.id
                    }, [
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(ledger.requestId), 1),
                          (ledger.serviceName?.String.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(ledger.serviceName?.String), 1))
                            : _createCommentVNode("", true),
                          (ledger.serviceName?.String.length <= 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(ledger.txnType.toUpperCase()), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_11, " UGX " + _toDisplayString(_unref(billingStore).getFormattedAmount(ledger.amount)), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(formatDate(ledger.createdAt)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[2] || (_cache[2] = _createTextVNode(" Showing ", -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(billingStore).pagination.currentPage), 1),
                    _cache[3] || (_cache[3] = _createTextVNode(" of ", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(billingStore).pagination.totalPages), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" results ", -1))
                  ]),
                  (_unref(billingStore).pagination.nextPage > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[5] || (_cache[5] = _createElementVNode("button", {
                          class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50",
                          disabled: ""
                        }, "Previous", -1)),
                        _createElementVNode("button", _hoisted_19, _toDisplayString(_unref(billingStore).pagination.nextPage), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("button", { class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" }, "Next", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})